import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  emailCampaignContext: {
    data: null,
    isLoaded: false,
  },
};

export const campaignHistorySlice = createSlice({
  name: "campaign_history_slice",
  initialState,
  reducers: {
    setEmailCampaignContext: (state, action) => {
      state.emailCampaignContext = {
        ...state.emailCampaignContext,
        data: action?.payload,
      };
    },
    setEmailCampaignTemplate: (state, action) => {
      state.emailCampaignContext = {
        ...state.emailCampaignContext,
        templateName: action?.payload,
      };
    },
    setEmailCampaignContextLoaded: (state, action) => {
      state.emailCampaignContext = {
        ...state.emailCampaignContext,
        isLoaded: action?.payload,
      };
    },
    resetCampaignHistoryReducerState: () => {
      return initialState;
    },
  },
});

export const {
  setEmailCampaignContext,
  setEmailCampaignTemplate,
  setEmailCampaignContextLoaded,
  resetCampaignHistoryReducerState,
} = campaignHistorySlice.actions;

export default campaignHistorySlice.reducer;
